import {Component, OnInit, Inject, Input} from 'ng-metadata/core';
import {PushtoService} from '../pushto.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service'
import {isBrowserSafari, isIosDevice} from '../../../infra/browserSniffer';
import {MediaQueries} from '../../../infra/mediaQueries.service';

@Component({
    selector: 'prm-export-bibtex',
    templateUrl: 'components/search/actions/exportBibTexAction/export-bibtex.html',
})

export class PrmExportBibtex implements OnInit{
       
    @Input() public selectedIds: Object;
    @Input() private item: Object;
    
    private encodingVal:string;
    private encodingList: string[];
    private popupWin : Window;
    
    constructor(private pushtoService: PushtoService,
                private mtCache:MappingTablesCache,
                private mediaQueries: MediaQueries,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$document') private $document) {
        this.setEncodingValues();
    }

    get encoding() {
        return this.encodingList;
    }


    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }
    
    public getFile() {
        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let enc = this.encodingVal || 'UTF-8';
        if (isIosDevice()) {
            this.popupWin = window.open('', 'ris');
        }
        let pushtoPromise = this.pushtoService.getServiceUrl([this.item], this.selectedIds, 'exportbibtex',{encoding: enc});
        pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
    }
    
    private successfullPushtoAction(response) {
        let enc = this.encodingVal || 'UTF-8';
        let blob = new Blob([response.data.data], {endings: 'native', type: 'text/plain;charset=' + enc});
        let filename = 'Primo_BibTeX_Export.bib';
        if (this.isBrowserMS()) {
            window.navigator.msSaveBlob(blob, filename);
        }else {
            let url = window.URL.createObjectURL(blob);
            let e = document.createEvent('MouseEvents');
            let a = document.createElement('a');

            try {
                a.download = filename;
                a.href = url;
                a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
            } catch (err) {console.log(err);}
            try {
                if (isIosDevice()) {
                    this.popupWin = window.open(url,'ris');
                }
                else {
                    e.initEvent('click', true, false);
                    a.dispatchEvent(e);
                }
            } catch (err) {}

            this.$timeout(function () {
                window.URL.revokeObjectURL(url);
            }, 600);
        }


    }
    
    private isBrowserMS() {
        return navigator.appVersion.toString().indexOf('.NET') > 0 ||
            window.navigator.userAgent.indexOf("Edge") > -1
    }

    private failedPushtoAction(response) {

    }
    
    private setEncodingValues() {
        let rows = this.mtCache.getTable(this.mtCache.tables.EXPORT_RIS_ENCODINGS);
        

        if (rows.length> 0){
            this.encodingList = rows.map((r)=>{return r.source1;});
        }
    }
    
    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/exportBibTexAction/exportBibtex.directive.ts